import { AltPhoneTypes } from '@bb/users';
import type { TabKey } from './types';

export const ALT_PHONE_TYPES = Object.values(AltPhoneTypes);

export const ERROR_MESSAGES = {
  address: 'Address is required.',
  altPhone: 'An alternate # must have a correct type.',
  branch: 'Branch is required.',
  branchAccess: 'Branch admin multi-access must include their own branch.',
  duplicateEmail: 'An account already exists with this email address.',
  email: 'A valid email is required.',
  firstName: 'First Name is required.',
  forwardUser: 'A user must be selected.',
  genericDate: 'A date must be selected.',
  invalidDateRange: 'The start date must be before the end date',
  lastName: 'Last Name is required.',
  licenseType: 'License type is required',
  maxNonBillableKeysReached:
    'You have issused the maximum number of training keys per your contract. Please unassign any training keys that may no longer be in use and try again.',
  mobile: 'Valid number is required',
  mlsNumbers: 'Please select at least one MLS number',
  mlsNumber: 'Please enter a valid unique MLS number',
  mlsBoard: 'Please select a license board',
  mlsUniqueId: 'Please select a unique identifier',
  name: 'A valid name is required.',
  nonMemberNoKeyTypes:
    'No key types available for non-member. Unable to subscribe.',
  password:
    'Your password must have a minimum of 8 characters, have 1 letter, 1 number, and 1 capital',
  supraCurrentPin: 'Please enter a current PIN.',
  supraConfirmingPin: "Passwords don't match.",
  supraSubscriptionKeyTypeRequired: 'A valid Key Type is required',
  supraSubscriptionSubRoleRequired:
    'A valid Sub Role is required for selected Key Type',
  team: 'Required for Team Admin.',
  teamAccess: 'Team admin multi-access must include their own team.',
  waiveActivationFeeReason: 'A reason for waiving the fee is required',
};

export const NO_BOARD = 'NO_BOARD';

export const NOT_EDITABLE_PAGE: TabKey[] = [
  'LIVE_CONCIERGE_SERVICE',
  'BILLING',
  'PERMISSIONS',
];

export const UNCLAIMED_ORG_NO_ACCESS_PAGES: TabKey[] = [
  'LISTING_SETTINGS',
  'LIVE_CONCIERGE_SERVICE',
];

export const REQUEST_TRANSFER_TEXT =
  'Are you sure you should request this transfer? Please confirm with the agent that their brokerage is aware of the transfer';

export const SUPRA_PIN_LENGTH = 4;
